import { authApiService } from '@/api/authApiService';
import { UpdateInvitedUserPayloadType, UpdateInvitedUserResponseType } from '@/api/types';
import { ApiResponseType } from '@/types/sharedTypes';

export type UpdateDepositorResponseType = UpdateInvitedUserResponseType & {
  id: string;
};

export const updateDepositorApi = (
  wireId: string,
  data: UpdateInvitedUserPayloadType
): Promise<ApiResponseType<UpdateDepositorResponseType>> => {
  const uri = `/organization/wires/${wireId}/depositor/`;

  return authApiService.PATCH(uri, data);
};
